function formatDate(value) {
  const raw = String(value || '').trim();
  if (!raw) {
    return '-';
  }

  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) {
    return raw;
  }

  return date.toLocaleString();
}

export function buildDocumentsTableModel(dtoRows) {
  return dtoRows.map((row) => ({
    key: row.key,
    name: row.name,
    type: row.type,
    status: row.status,
    profileId: row.profileId,
    profileName: row.profileName,
    assignedToId: row.assignedToId,
    assignedToName: row.assignedToName,
    translation: row.translation,
    translationRequired: row.translationRequired,
    createdAt: formatDate(row.created),
    modifiedAt: formatDate(row.modified),
    expirationAt: formatDate(row.expiration),
    source: row,
  }));
}

function includesPart(value, query) {
  const haystack = String(value || '').trim().toLowerCase();
  const needle = String(query || '').trim().toLowerCase();

  if (!needle) {
    return true;
  }

  return haystack.includes(needle);
}

export function filterDocumentsRows(rows, filters) {
  return rows.filter((row) => {
    const byType = includesPart(row.type, filters.type);
    const byStatus = includesPart(row.status, filters.status);
    const byTranslationRequired = !filters.translationRequired || row.translationRequired === true
      || String(row.translationRequired || '').trim().toLowerCase() === 'true'
      || String(row.translationRequired || '').trim() === '1';

    return byType && byStatus && byTranslationRequired;
  });
}
